module.exports = __webpack_public_path__ + "img/CF_1M.7604ba8c.jpg";